module.exports = __webpack_public_path__ + "img/edit.12e404c0.svg";